/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consult_TitleInputs */

const en_consult_title = /** @type {(inputs: Consult_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consulting`)
};

const id_consult_title = /** @type {(inputs: Consult_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konsultasi`)
};

/**
* | output |
* | --- |
* | "Consulting" |
*
* @param {Consult_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const consult_title = /** @type {((inputs?: Consult_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consult_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_consult_title(inputs)
	return en_consult_title(inputs)
});